// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__2MB9k","spin":"Spinner_spin__2yCxK","container":"Spinner_container__3_HXs"};